// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icons/gear.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/icons/journal-code.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/icons/clipboard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/icons/file-earmark-text.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/icons/camera.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/icons/download.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/icons/palette.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/icons/paint-bucket.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/icons/type-bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images/icons/type-italic.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/images/icons/trash.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/images/icons/code.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/images/icons/type-underline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images/icons/type-strikethrough.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/images/icons/type-subscript.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/images/icons/type-superscript.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../assets/images/icons/link.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../assets/images/icons/horizontal-rule.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../assets/images/icons/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../assets/images/icons/caret-right-fill.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../assets/images/icons/dropdown-more.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../assets/images/icons/font-color.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../assets/images/icons/font-family.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../assets/images/icons/bg-color.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../assets/images/icons/table.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../assets/images/icons/file-image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../assets/images/icons/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../assets/images/icons/figma.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../assets/images/icons/card-checklist.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../assets/images/icons/3-columns.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../../assets/images/icons/tweet.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../../assets/images/icons/youtube.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../../assets/images/icons/text-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../../assets/images/icons/text-center.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../../assets/images/icons/text-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../../assets/images/icons/justify.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../../assets/images/icons/indent.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../../assets/images/icons/markdown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../../assets/images/icons/outdent.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../../assets/images/icons/arrow-counterclockwise.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../../assets/images/icons/arrow-clockwise.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../../assets/images/icons/sticky.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../../assets/images/icons/mic.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../../assets/images/icons/upload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../../assets/images/icons/diagram-2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../../assets/images/icons/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../../assets/images/icons/plus-slash-minus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../../assets/images/icons/filetype-gif.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../../assets/images/icons/copy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../../assets/images/icons/success.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../../assets/images/icons/prettier.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../../assets/images/icons/prettier-error.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../../assets/images/icons/scissors.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../../assets/images/icons/success-alt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../../assets/images/icons/text-paragraph.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../../assets/images/icons/type-h1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../../assets/images/icons/type-h2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../../assets/images/icons/type-h3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../../assets/images/icons/type-h4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../../assets/images/icons/type-h5.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../../assets/images/icons/type-h6.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../../assets/images/icons/list-ul.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../../assets/images/icons/square-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../../assets/images/icons/list-ol.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../../assets/images/icons/chat-square-quote.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../../assets/images/emoji/1F642.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../../assets/images/emoji/1F600.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../../assets/images/emoji/1F641.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../../assets/images/emoji/2764.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../../assets/images/icons/lock-fill.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../../assets/images/icons/lock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../../assets/images/icons/plug.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../../assets/images/icons/plug-fill.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../../assets/images/icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Reenie+Beanie);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

body {
  margin: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #eee;
  padding: 0px;
}

header {
  max-width: 580px;
  margin: auto;
  position: relative;
  display: flex;
  justify-content: center;
}

header a {
  max-width: 220px;
  margin: 20px 0 0 0;
  display: block;
}

header img {
  display: block;
  height: 100%;
  width: 100%;
}

header h1 {
  text-align: left;
  color: #333;
  display: inline-block;
  margin: 20px 0 0 0;
}

.editor-shell {
  margin: 20px auto;
  border-radius: 2px;
  max-width: 1100px;
  color: #000;
  position: relative;
  line-height: 1.7;
  font-weight: 400;
}

.editor-shell .editor-container {
  background: #fff;
  position: relative;
  display: block;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.editor-shell .editor-container.tree-view {
  border-radius: 0;
}

.editor-shell .editor-container.plain-text {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.editor-scroller {
  min-height: 150px;
  border: 0;
  display: flex;
  position: relative;
  outline: 0;
  z-index: 0;
  overflow: auto;
  resize: vertical;
}

.editor {
  flex: auto;
  position: relative;
  resize: vertical;
  z-index: -1;
}

.test-recorder-output {
  margin: 20px auto 20px auto;
  width: 100%;
}

pre {
  line-height: 1.1;
  /* background: #222;
  color: #fff; */
  margin: 0;
  padding: 10px;
  font-size: 12px;
  overflow: auto;
  max-height: 400px;
}

.tree-view-output {
  display: block;
  background: #222;
  color: #fff;
  padding: 0;
  font-size: 12px;
  margin: 1px auto 10px auto;
  position: relative;
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

pre::-webkit-scrollbar {
  background: transparent;
  width: 10px;
}

pre::-webkit-scrollbar-thumb {
  background: #999;
}

.editor-dev-button {
  position: relative;
  display: block;
  width: 40px;
  height: 40px;
  font-size: 12px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  outline: none;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.3);
  background-color: #444;
}

.editor-dev-button::after {
  content: '';
  position: absolute;
  top: 10px;
  right: 10px;
  bottom: 10px;
  left: 10px;
  display: block;
  background-size: contain;
  filter: invert(1);
}

.editor-dev-button:hover {
  background-color: #555;
}

.editor-dev-button.active {
  background-color: rgb(233, 35, 35);
}

.test-recorder-toolbar {
  display: flex;
}

.test-recorder-button {
  position: relative;
  display: block;
  width: 32px;
  height: 32px;
  font-size: 10px;
  padding: 6px 6px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  outline: none;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.4);
  background-color: #222;
  transition: box-shadow 50ms ease-out;
}

.test-recorder-button:active {
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4);
}

.test-recorder-button+.test-recorder-button {
  margin-left: 4px;
}

.test-recorder-button::after {
  content: '';
  position: absolute;
  top: 8px;
  right: 8px;
  bottom: 8px;
  left: 8px;
  display: block;
  background-size: contain;
  filter: invert(1);
}

#options-button {
  position: fixed;
  left: 20px;
  bottom: 20px;
}

#test-recorder-button {
  position: fixed;
  left: 70px;
  bottom: 20px;
}

#paste-log-button {
  position: fixed;
  left: 120px;
  bottom: 20px;
}

#docs-button {
  position: fixed;
  left: 170px;
  bottom: 20px;
}

#options-button::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

#test-recorder-button::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

#paste-log-button::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

#docs-button::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

#test-recorder-button-snapshot {
  margin-right: auto;
}

#test-recorder-button-snapshot::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

#test-recorder-button-copy::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

#test-recorder-button-download::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.typeahead-popover {
  background: #fff;
  border: 1px solid gray;
  box-shadow: 6px 6px 1px rgba(0, 0, 0, 10%);
  position: fixed;
}

.typeahead-popover ul {
  padding: 0;
  list-style: none;
  margin: 0;
  /* border-radius: 8px; */
  max-height: 200px;
  overflow-y: scroll;
}

.typeahead-popover ul::-webkit-scrollbar {
  display: none;
}

.typeahead-popover ul {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.typeahead-popover ul li {
  margin: 0;
  min-width: 180px;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  /* border-radius: 8px; */
}

.typeahead-popover ul li.selected {
  background: #eee;
}

.typeahead-popover li {
  margin: 0 8px 0 8px;
  padding: 8px;
  color: #050505;
  cursor: pointer;
  line-height: 16px;
  font-size: 15px;
  display: flex;
  align-content: center;
  flex-direction: row;
  flex-shrink: 0;
  background-color: #fff;
  /* border-radius: 8px; */
  border: 0;
}

.typeahead-popover li.active {
  display: flex;
  width: 20px;
  height: 20px;
  background-size: contain;
}

/* .typeahead-popover li:first-child {
  border-radius: 8px 8px 0px 0px;
}

.typeahead-popover li:last-child {
  border-radius: 0px 0px 8px 8px;
} */

.typeahead-popover li:hover {
  background-color: #eee;
}

.typeahead-popover li .text {
  display: flex;
  line-height: 20px;
  flex-grow: 1;
  min-width: 150px;
}

.typeahead-popover li .icon {
  display: flex;
  width: 20px;
  height: 20px;
  -webkit-user-select: none;
          user-select: none;
  margin-right: 8px;
  line-height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.component-picker-menu {
  width: 200px;
}

.mentions-menu {
  width: 250px;
}

.auto-embed-menu {
  width: 0px;
  border: none;
}

.emoji-menu {
  width: 200px;
}

i.palette {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

i.bucket {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

i.bold {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

i.italic {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

i.clear {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

i.code {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

i.underline {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

i.strikethrough {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

i.subscript {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

i.superscript {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

i.link {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

i.horizontal-rule {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.icon.plus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.icon.caret-right {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.icon.dropdown-more {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.icon.font-color {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.icon.font-family {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.icon.bg-color {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.icon.table {
  background-color: #6c757d;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-size: contain;
}

i.image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

i.table {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

i.close {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

i.figma {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

i.poll {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

i.columns {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

i.tweet {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

i.youtube {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

.icon.left-align,
i.left-align {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

.icon.center-align,
i.center-align {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

.icon.right-align,
i.right-align {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.icon.justify-align,
i.justify-align {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

i.indent {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

i.markdown {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}

i.outdent {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

i.undo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

i.redo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

i.sticky {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

i.mic {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

i.import {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}

i.export {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

i.diagram-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}

i.user {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

i.equation {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

i.gif {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

i.copy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

i.success {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

i.prettier {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}

i.prettier-error {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}

i.page-break,
.icon.page-break {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

.link-editor .button.active,
.toolbar .button.active {
  background-color: rgb(223, 232, 250);
}

.link-editor .link-input {
  display: block;
  width: calc(100% - 75px);
  box-sizing: border-box;
  margin: 12px 12px;
  padding: 8px 12px;
  border-radius: 15px;
  background-color: #eee;
  font-size: 15px;
  color: rgb(5, 5, 5);
  border: 0;
  outline: 0;
  position: relative;
  font-family: inherit;
}

.link-editor .link-view {
  display: block;
  width: calc(100% - 24px);
  margin: 8px 12px;
  padding: 8px 12px;
  border-radius: 15px;
  font-size: 15px;
  color: rgb(5, 5, 5);
  border: 0;
  outline: 0;
  position: relative;
  font-family: inherit;
}

.link-editor .link-view a {
  display: block;
  word-break: break-word;
  width: calc(100% - 33px);
}

/* 
.link-editor div.link-edit {
  background-image: url(../../assets/images/icons/pencil-fill.svg);
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 35px;
  vertical-align: -0.25em;
  position: absolute;
  right: 30px;
  top: 0;
  bottom: 0;
  cursor: pointer;
} */

.link-editor div.link-trash {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 35px;
  vertical-align: -0.25em;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.link-editor div.link-cancel {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 35px;
  vertical-align: -0.25em;
  margin-right: 28px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.link-editor div.link-confirm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 35px;
  vertical-align: -0.25em;
  margin-right: 2px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.link-editor .link-input a {
  color: rgb(33, 111, 219);
  text-decoration: underline;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 30px;
  text-overflow: ellipsis;
}

.link-editor .link-input a:hover {
  text-decoration: underline;
}

.link-editor .font-size-wrapper,
.link-editor .font-family-wrapper {
  display: flex;
  margin: 0 4px;
}

.link-editor select {
  padding: 6px;
  border: none;
  background-color: rgba(0, 0, 0, 0.075);
  border-radius: 4px;
}

.mention:focus {
  box-shadow: rgb(180 213 255) 0px 0px 0px 2px;
  outline: none;
}

.characters-limit {
  color: #888;
  font-size: 12px;
  text-align: right;
  display: block;
  position: absolute;
  left: 12px;
  bottom: 5px;
}

.characters-limit.characters-limit-exceeded {
  color: red;
}

.dropdown {
  z-index: 100;
  display: block;
  position: fixed;
  box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1),
    inset 0 0 0 1px rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  min-height: 40px;
  background-color: #fff;
}

.dropdown .item {
  margin: 0 8px 0 8px;
  padding: 8px;
  color: #050505;
  cursor: pointer;
  line-height: 16px;
  font-size: 15px;
  display: flex;
  align-content: center;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 8px;
  border: 0;
  max-width: 250px;
  min-width: 100px;
}

.dropdown .item.fontsize-item,
.dropdown .item.fontsize-item .text {
  min-width: unset;
}

.dropdown .item .active {
  display: flex;
  width: 20px;
  height: 20px;
  background-size: contain;
}

.dropdown .item:first-child {
  margin-top: 8px;
}

.dropdown .item:last-child {
  margin-bottom: 8px;
}

.dropdown .item:hover {
  background-color: #eee;
}

.dropdown .item .text {
  display: flex;
  line-height: 20px;
  flex-grow: 1;
  min-width: 150px;
}

.dropdown .item .icon {
  display: flex;
  width: 20px;
  height: 20px;
  -webkit-user-select: none;
          user-select: none;
  margin-right: 12px;
  line-height: 16px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.dropdown .divider {
  width: auto;
  background-color: #eee;
  margin: 4px 8px;
  height: 1px;
}

@media screen and (max-width: 1100px) {
  .dropdown-button-text {
    display: none !important;
  }

  .dialog-dropdown>.dropdown-button-text {
    display: flex !important;
  }

  .font-size .dropdown-button-text {
    display: flex !important;
  }

  .code-language .dropdown-button-text {
    display: flex !important;
  }
}

.icon.paragraph {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}

.icon.h1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

.icon.h2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}

.icon.h3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}

.icon.h4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}

.icon.h5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}

.icon.h6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
}

.icon.bullet-list,
.icon.bullet {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}

.icon.check-list,
.icon.check {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}

.icon.numbered-list,
.icon.number {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}

.icon.quote {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}

.icon.code {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.switches {
  z-index: 6;
  position: fixed;
  left: 10px;
  bottom: 70px;
  animation: slide-in 0.4s ease;
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateX(-200px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.switch {
  display: block;
  color: #444;
  margin: 5px 0;
  background-color: rgba(238, 238, 238, 0.7);
  padding: 5px 10px;
  border-radius: 10px;
}

#rich-text-switch {
  right: 0;
}

#character-count-switch {
  right: 130px;
}

.switch label {
  margin-right: 5px;
  line-height: 24px;
  width: 100px;
  font-size: 14px;
  display: inline-block;
  vertical-align: middle;
}

.switch button {
  background-color: rgb(206, 208, 212);
  height: 24px;
  box-sizing: border-box;
  border-radius: 12px;
  width: 44px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  outline: none;
  cursor: pointer;
  transition: background-color 0.1s;
  border: 2px solid transparent;
}

.switch button:focus-visible {
  border-color: blue;
}

.switch button span {
  top: 0px;
  left: 0px;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 12px;
  background-color: white;
  transition: transform 0.2s;
}

.switch button[aria-checked='true'] {
  background-color: rgb(24, 119, 242);
}

.switch button[aria-checked='true'] span {
  transform: translateX(20px);
}

.editor-shell span.editor-image {
  cursor: default;
  display: inline-block;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.editor-shell .editor-image img {
  max-width: 100%;
  cursor: default;
}

.editor-shell .editor-image img.focused {
  outline: 2px solid rgb(60, 132, 244);
  -webkit-user-select: none;
          user-select: none;
}

.editor-shell .editor-image img.focused.draggable {
  cursor: grab;
}

.editor-shell .editor-image img.focused.draggable:active {
  cursor: grabbing;
}

.editor-shell .editor-image .image-caption-container .tree-view-output {
  margin: 0;
  border-radius: 0;
}

.editor-shell .editor-image .image-caption-container {
  display: block;
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  padding: 0;
  margin: 0;
  border-top: 1px solid #fff;
  background-color: rgba(255, 255, 255, 0.9);
  min-width: 100px;
  color: #000;
  overflow: hidden;
}

.editor-shell .editor-image .image-caption-button {
  display: block;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  width: 30%;
  padding: 10px;
  margin: 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  min-width: 100px;
  color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.editor-shell .editor-image .image-caption-button:hover {
  background-color: rgba(60, 132, 244, 0.5);
}

/* .editor-shell .editor-image .image-edit-button {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-image: url(/src/../../assets/images/icons/pencil-fill.svg);
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 35px;
  height: 35px;
  vertical-align: -0.25em;
  position: absolute;
  right: 4px;
  top: 4px;
  cursor: pointer;
  user-select: none;
} */

.editor-shell .editor-image .image-edit-button:hover {
  background-color: rgba(60, 132, 244, 0.1);
}

.editor-shell .editor-image .image-resizer {
  display: block;
  width: 7px;
  height: 7px;
  position: absolute;
  background-color: rgb(60, 132, 244);
  border: 1px solid #fff;
}

.editor-shell .editor-image .image-resizer.image-resizer-n {
  top: -6px;
  left: 48%;
  cursor: n-resize;
}

.editor-shell .editor-image .image-resizer.image-resizer-ne {
  top: -6px;
  right: -6px;
  cursor: ne-resize;
}

.editor-shell .editor-image .image-resizer.image-resizer-e {
  bottom: 48%;
  right: -6px;
  cursor: e-resize;
}

.editor-shell .editor-image .image-resizer.image-resizer-se {
  bottom: -2px;
  right: -6px;
  cursor: nwse-resize;
}

.editor-shell .editor-image .image-resizer.image-resizer-s {
  bottom: -2px;
  left: 48%;
  cursor: s-resize;
}

.editor-shell .editor-image .image-resizer.image-resizer-sw {
  bottom: -2px;
  left: -6px;
  cursor: sw-resize;
}

.editor-shell .editor-image .image-resizer.image-resizer-w {
  bottom: 48%;
  left: -6px;
  cursor: w-resize;
}

.editor-shell .editor-image .image-resizer.image-resizer-nw {
  top: -6px;
  left: -6px;
  cursor: nw-resize;
}

.editor-shell span.inline-editor-image {
  cursor: default;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.editor-shell .inline-editor-image img {
  max-width: 100%;
  cursor: default;
}

.editor-shell .inline-editor-image img.focused {
  outline: 2px solid rgb(60, 132, 244);
}

.editor-shell .inline-editor-image img.focused.draggable {
  cursor: grab;
}

.editor-shell .inline-editor-image img.focused.draggable:active {
  cursor: grabbing;
}

.editor-shell .inline-editor-image .image-caption-container .tree-view-output {
  margin: 0;
  border-radius: 0;
}

.editor-shell .inline-editor-image.position-full {
  margin: 1em 0 1em 0;
}

.editor-shell .inline-editor-image.position-left {
  float: left;
  width: 50%;
  margin: 1em 1em 0 0;
}

.editor-shell .inline-editor-image.position-right {
  float: right;
  width: 50%;
  margin: 1em 0 0 1em;
}

.editor-shell .inline-editor-image .image-edit-button {
  display: block;
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 6px 8px;
  margin: 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  min-width: 60px;
  color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.editor-shell .inline-editor-image .image-edit-button:hover {
  background-color: rgba(60, 132, 244, 0.5);
}

.editor-shell .inline-editor-image .image-caption-container {
  display: block;
  background-color: #f4f4f4;
  min-width: 100%;
  color: #000;
  overflow: hidden;
}

.emoji {
  color: transparent;
  caret-color: rgb(5, 5, 5);
  background-size: 16px 16px;
  background-position: center;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin: 0 -1px;
}

.emoji-inner {
  padding: 0 0.15em;
}

.emoji-inner::selection {
  color: transparent;
  background-color: rgba(150, 150, 150, 0.4);
}

.emoji-inner::moz-selection {
  color: transparent;
  background-color: rgba(150, 150, 150, 0.4);
}

.emoji.happysmile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}

.emoji.veryhappysmile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
}

.emoji.unhappysmile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}

.emoji.heart {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}

.keyword {
  color: rgb(241, 118, 94);
  font-weight: bold;
}

.actions {
  position: absolute;
  text-align: right;
  margin: 10px;
  bottom: 0;
  right: 0;
}

.actions.tree-view {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.actions i {
  background-size: contain;
  display: inline-block;
  height: 15px;
  width: 15px;
  vertical-align: -0.25em;
}

.actions i.indent {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

.actions i.outdent {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.actions i.lock {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}

.actions i.image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.actions i.table {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.actions i.unlock {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
}

.actions i.left-align {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

.actions i.center-align {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

.actions i.right-align {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.actions i.justify-align {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.actions i.disconnect {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
}

.actions i.connect {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
}

.table-cell-action-button-container {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
}

.table-cell-action-button {
  background-color: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  position: relative;
  border-radius: 15px;
  color: #222;
  display: inline-block;
  cursor: pointer;
}

i.chevron-down {
  background-color: transparent;
  background-size: contain;
  display: inline-block;
  height: 8px;
  width: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
}

.action-button {
  background-color: #eee;
  border: 0;
  padding: 8px 12px;
  position: relative;
  margin-left: 5px;
  border-radius: 15px;
  color: #222;
  display: inline-block;
  cursor: pointer;
}

.action-button:hover {
  background-color: #ddd;
  color: #000;
}

.action-button-mic.active {
  animation: mic-pulsate-color 3s infinite;
}

button.action-button:disabled {
  opacity: 0.6;
  background: #eee;
  cursor: not-allowed;
}

@keyframes mic-pulsate-color {
  0% {
    background-color: #ffdcdc;
  }

  50% {
    background-color: #ff8585;
  }

  100% {
    background-color: #ffdcdc;
  }
}

.debug-timetravel-panel {
  overflow: hidden;
  padding: 0 0 10px 0;
  margin: auto;
  display: flex;
}

.debug-timetravel-panel-slider {
  padding: 0;
  flex: 8;
}

.debug-timetravel-panel-button {
  padding: 0;
  border: 0;
  background: none;
  flex: 1;
  color: #fff;
  font-size: 12px;
}

.debug-timetravel-panel-button:hover {
  text-decoration: underline;
}

.debug-timetravel-button {
  border: 0;
  padding: 0;
  font-size: 12px;
  top: 10px;
  right: 15px;
  position: absolute;
  background: none;
  color: #fff;
}

.debug-timetravel-button:hover {
  text-decoration: underline;
}

.debug-treetype-button {
  border: 0;
  padding: 0;
  font-size: 12px;
  top: 10px;
  right: 85px;
  position: absolute;
  background: none;
  color: #fff;
}

.debug-treetype-button:hover {
  text-decoration: underline;
}

.connecting {
  font-size: 15px;
  color: #999;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 10px;
  left: 10px;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  display: inline-block;
  pointer-events: none;
}

.ltr {
  text-align: left;
}

.rtl {
  text-align: right;
}

.toolbar {
  display: flex;
  vertical-align: middle;
  overflow: auto;
  height: 24px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

button.toolbar-item {
  border: 0;
  display: flex;
  background: none;
  border-radius: 2px;
  padding: 3px;
  cursor: pointer;
  vertical-align: middle;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
}

button.toolbar-item:disabled {
  cursor: not-allowed;
}

button.toolbar-item.spaced {
  margin-right: 2px;
}

button.toolbar-item i.format {
  background-size: contain;
  display: inline-block;
  height: 18px;
  width: 18px;
  vertical-align: -0.25em;
  display: flex;
  opacity: 0.6;
}

button.toolbar-item:disabled .icon,
button.toolbar-item:disabled .text,
button.toolbar-item:disabled i.format,
button.toolbar-item:disabled .chevron-down {
  opacity: 0.2;
}

button.toolbar-item.active {
  background-color: rgba(223, 232, 250, 0.3);
}

button.toolbar-item.active i {
  opacity: 1;
}

.toolbar-item:hover:not([disabled]) {
  background-color: rgba(0, 0, 0, 0.1);
}

.toolbar-item.font-family .text {
  display: block;
  max-width: 40px;
}

.toolbar .code-language {
  width: 150px;
}

.toolbar .toolbar-item .text {
  display: flex;
  line-height: 20px;
  vertical-align: middle;
  font-size: 14px;
  color: #777;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 20px;
  text-align: left;
  padding-right: 10px;
}

.toolbar .toolbar-item .icon {
  display: flex;
  width: 15px;
  height: 15px;
  -webkit-user-select: none;
          user-select: none;
  margin-right: 2px;
  line-height: 14px;
  background-size: contain;
}

.toolbar i.chevron-down,
.toolbar-item i.chevron-down {
  margin-top: 2px;
  width: 8px;
  height: 8px;
  display: flex;
  -webkit-user-select: none;
          user-select: none;
}

.toolbar i.chevron-down.inside {
  width: 8px;
  height: 8px;
  display: flex;
  margin-left: -25px;
  margin-top: 11px;
  margin-right: 10px;
  pointer-events: none;
}

.toolbar .divider {
  width: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 0 2px;
}

.sticky-note-container {
  position: absolute;
  z-index: 9;
  width: 120px;
  display: inline-block;
}

.sticky-note {
  line-height: 1;
  text-align: left;
  width: 120px;
  margin: 25px;
  padding: 20px 10px;
  position: relative;
  border: 1px solid #e8e8e8;
  font-family: 'Reenie Beanie';
  font-size: 24px;
  border-bottom-right-radius: 60px 5px;
  display: block;
  cursor: move;
}

.sticky-note:after {
  content: '';
  position: absolute;
  z-index: -1;
  right: -0px;
  bottom: 20px;
  width: 120px;
  height: 25px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 2px 15px 5px rgba(0, 0, 0, 0.4);
  transform: matrix(-1, -0.1, 0, 1, 0, 0);
}

.sticky-note.yellow {
  border-top: 1px solid #fdfd86;
  background: linear-gradient(135deg,
      #ffff88 81%,
      #ffff88 82%,
      #ffff88 82%,
      #ffffc6 100%);
}

.sticky-note.pink {
  border-top: 1px solid #e7d1e4;
  background: linear-gradient(135deg,
      #f7cbe8 81%,
      #f7cbe8 82%,
      #f7cbe8 82%,
      #e7bfe1 100%);
}

.sticky-note-container.dragging {
  transition: none !important;
}

.sticky-note div {
  cursor: text;
}

.sticky-note .delete {
  border: 0;
  background: none;
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 10px;
  cursor: pointer;
  opacity: 0.5;
}

.sticky-note .delete:hover {
  font-weight: bold;
  opacity: 1;
}

.sticky-note .color {
  border: 0;
  background: none;
  position: absolute;
  top: 8px;
  right: 25px;
  cursor: pointer;
  opacity: 0.5;
}

.sticky-note .color:hover {
  opacity: 1;
}

.sticky-note .color i {
  display: block;
  width: 12px;
  height: 12px;
  background-size: contain;
}

.excalidraw-button {
  border: 0;
  padding: 0;
  margin: 0;
  background-color: transparent;
}

.excalidraw-button.selected {
  outline: 2px solid rgb(60, 132, 244);
  -webkit-user-select: none;
          user-select: none;
}

.github-corner:hover .octo-arm {
  animation: octocat-wave 560ms ease-in-out;
}

@keyframes octocat-wave {

  0%,
  100% {
    transform: rotate(0);
  }

  20%,
  60% {
    transform: rotate(-25deg);
  }

  40%,
  80% {
    transform: rotate(10deg);
  }
}

@media (max-width: 500px) {
  .github-corner:hover .octo-arm {
    animation: none;
  }

  .github-corner .octo-arm {
    animation: octocat-wave 560ms ease-in-out;
  }
}

.spacer {
  letter-spacing: -2px;
}

.editor-equation {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
}

.editor-equation.focused {
  outline: 2px solid rgb(60, 132, 244);
}

button.item i {
  opacity: 0.6;
}

button.item.dropdown-item-active {
  background-color: rgba(223, 232, 250, 0.3);
}

button.item.dropdown-item-active i {
  opacity: 1;
}

hr {
  /* padding: 2px 2px; */
  margin: 2px 2px;
  border: none;
  margin: 1em 0;
  cursor: pointer;
}

hr:after {
  content: '';
  display: block;
  height: 2px;
  background-color: #ccc;
  line-height: 2px;
}

hr.selected {
  outline: 2px solid rgb(60, 132, 244);
  -webkit-user-select: none;
          user-select: none;
}

.TableNode__contentEditable {
  min-height: 20px;
  border: 0px;
  resize: none;
  cursor: text;
  display: block;
  position: relative;
  outline: 0px;
  padding: 0;
  -webkit-user-select: text;
          user-select: text;
  font-size: 15px;
  white-space: pre-wrap;
  word-break: break-word;
  z-index: 3;
}

.PlaygroundEditorTheme__blockCursor {
  display: block;
  pointer-events: none;
  position: absolute;
}

.PlaygroundEditorTheme__blockCursor:after {
  content: '';
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: CursorBlink 1.1s steps(2, start) infinite;
}

@keyframes CursorBlink {
  to {
    visibility: hidden;
  }
}

.dialog-dropdown {
  background-color: #eee !important;
  margin-bottom: 10px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/lexical-plugins/index.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAIF;EACE,SAAS;EACT;cACY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB;gBACc;EACd,SAAS;EACT,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAiE;AACnE;;AAEA;EACE,yDAA8D;AAChE;;AAEA;EACE,yDAAsE;AACxE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yDAA2D;AAC7D;;AAEA;EACE,yDAA8D;AAChE;;AAEA;EACE,yDAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;;;;;GAMG;;AAEH;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,yDAAiE;AACnE;;AAEA;EACE,yDAA8D;AAChE;;AAEA;EACE,yDAAgE;AAClE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,0DAAuE;AACzE;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,0DAAqE;AACvE;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,0DAAoE;AACtE;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,0DAAqE;AACvE;;AAEA;EACE,0DAAkE;AACpE;;AAEA;EACE,0DAA+D;AACjE;;AAEA;EACE,0DAAgE;AAClE;;AAEA;EACE,0DAA6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;EACpD,4DAA4D;EAC5D,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,0DAA+D;AACjE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,0DAA8D;AAChE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;;EAEE,0DAA8D;AAChE;;AAEA;;EAEE,0DAAgE;AAClE;;AAEA;;EAEE,0DAA+D;AACjE;;AAEA;;EAEE,0DAA4D;AAC9D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA6D;AAC/D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAA2E;AAC7E;;AAEA;EACE,0DAAoE;AACtE;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAAwD;AAC1D;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,yDAA6D;AAC/D;;AAEA;EACE,0DAA8D;AAChE;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,0DAAqE;AACvE;;AAEA;EACE,0DAAiE;AACnE;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAA6D;AAC/D;;AAEA;EACE,0DAAmE;AACrE;;AAEA;;EAEE,0DAA6D;AAC/D;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,0DAA0D;EAC1D,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0DAA0D;EAC1D,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0DAAgE;EAChE,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf;4CAC0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;;EAEE,0DAA4D;AAC9D;;AAEA;;EAEE,0DAAiE;AACnE;;AAEA;;EAEE,0DAA4D;AAC9D;;AAEA;EACE,0DAAsE;AACxE;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,eAAe;EACf,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;EACb,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAA8D;AAChE;;AAEA;EACE,0DAA+D;AACjE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,0DAA8D;AAChE;;AAEA;EACE,0DAAgE;AAClE;;AAEA;EACE,0DAA+D;AACjE;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,0DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,0DAAiE;AACnE;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,OAAO;AACT;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B;;;;mBAIiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B;;;;mBAIiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE;;IAEE,oBAAoB;EACtB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/**\n * Copyright (c) Meta Platforms, Inc. and affiliates.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n *\n */\n\n@import 'https://fonts.googleapis.com/css?family=Reenie+Beanie';\n\nbody {\n  margin: 0;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #eee;\n  padding: 0px;\n}\n\nheader {\n  max-width: 580px;\n  margin: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\nheader a {\n  max-width: 220px;\n  margin: 20px 0 0 0;\n  display: block;\n}\n\nheader img {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\nheader h1 {\n  text-align: left;\n  color: #333;\n  display: inline-block;\n  margin: 20px 0 0 0;\n}\n\n.editor-shell {\n  margin: 20px auto;\n  border-radius: 2px;\n  max-width: 1100px;\n  color: #000;\n  position: relative;\n  line-height: 1.7;\n  font-weight: 400;\n}\n\n.editor-shell .editor-container {\n  background: #fff;\n  position: relative;\n  display: block;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.editor-shell .editor-container.tree-view {\n  border-radius: 0;\n}\n\n.editor-shell .editor-container.plain-text {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.editor-scroller {\n  min-height: 150px;\n  border: 0;\n  display: flex;\n  position: relative;\n  outline: 0;\n  z-index: 0;\n  overflow: auto;\n  resize: vertical;\n}\n\n.editor {\n  flex: auto;\n  position: relative;\n  resize: vertical;\n  z-index: -1;\n}\n\n.test-recorder-output {\n  margin: 20px auto 20px auto;\n  width: 100%;\n}\n\npre {\n  line-height: 1.1;\n  /* background: #222;\n  color: #fff; */\n  margin: 0;\n  padding: 10px;\n  font-size: 12px;\n  overflow: auto;\n  max-height: 400px;\n}\n\n.tree-view-output {\n  display: block;\n  background: #222;\n  color: #fff;\n  padding: 0;\n  font-size: 12px;\n  margin: 1px auto 10px auto;\n  position: relative;\n  overflow: hidden;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\npre::-webkit-scrollbar {\n  background: transparent;\n  width: 10px;\n}\n\npre::-webkit-scrollbar-thumb {\n  background: #999;\n}\n\n.editor-dev-button {\n  position: relative;\n  display: block;\n  width: 40px;\n  height: 40px;\n  font-size: 12px;\n  border-radius: 20px;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.3);\n  background-color: #444;\n}\n\n.editor-dev-button::after {\n  content: '';\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  bottom: 10px;\n  left: 10px;\n  display: block;\n  background-size: contain;\n  filter: invert(1);\n}\n\n.editor-dev-button:hover {\n  background-color: #555;\n}\n\n.editor-dev-button.active {\n  background-color: rgb(233, 35, 35);\n}\n\n.test-recorder-toolbar {\n  display: flex;\n}\n\n.test-recorder-button {\n  position: relative;\n  display: block;\n  width: 32px;\n  height: 32px;\n  font-size: 10px;\n  padding: 6px 6px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.4);\n  background-color: #222;\n  transition: box-shadow 50ms ease-out;\n}\n\n.test-recorder-button:active {\n  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4);\n}\n\n.test-recorder-button+.test-recorder-button {\n  margin-left: 4px;\n}\n\n.test-recorder-button::after {\n  content: '';\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  bottom: 8px;\n  left: 8px;\n  display: block;\n  background-size: contain;\n  filter: invert(1);\n}\n\n#options-button {\n  position: fixed;\n  left: 20px;\n  bottom: 20px;\n}\n\n#test-recorder-button {\n  position: fixed;\n  left: 70px;\n  bottom: 20px;\n}\n\n#paste-log-button {\n  position: fixed;\n  left: 120px;\n  bottom: 20px;\n}\n\n#docs-button {\n  position: fixed;\n  left: 170px;\n  bottom: 20px;\n}\n\n#options-button::after {\n  background-image: url(../../assets/images/icons/gear.svg);\n}\n\n#test-recorder-button::after {\n  background-image: url(../../assets/images/icons/journal-code.svg);\n}\n\n#paste-log-button::after {\n  background-image: url(../../assets/images/icons/clipboard.svg);\n}\n\n#docs-button::after {\n  background-image: url(../../assets/images/icons/file-earmark-text.svg);\n}\n\n#test-recorder-button-snapshot {\n  margin-right: auto;\n}\n\n#test-recorder-button-snapshot::after {\n  background-image: url(../../assets/images/icons/camera.svg);\n}\n\n#test-recorder-button-copy::after {\n  background-image: url(../../assets/images/icons/clipboard.svg);\n}\n\n#test-recorder-button-download::after {\n  background-image: url(../../assets/images/icons/download.svg);\n}\n\n.typeahead-popover {\n  background: #fff;\n  border: 1px solid gray;\n  box-shadow: 6px 6px 1px rgba(0, 0, 0, 10%);\n  position: fixed;\n}\n\n.typeahead-popover ul {\n  padding: 0;\n  list-style: none;\n  margin: 0;\n  /* border-radius: 8px; */\n  max-height: 200px;\n  overflow-y: scroll;\n}\n\n.typeahead-popover ul::-webkit-scrollbar {\n  display: none;\n}\n\n.typeahead-popover ul {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.typeahead-popover ul li {\n  margin: 0;\n  min-width: 180px;\n  font-size: 14px;\n  outline: none;\n  cursor: pointer;\n  /* border-radius: 8px; */\n}\n\n.typeahead-popover ul li.selected {\n  background: #eee;\n}\n\n.typeahead-popover li {\n  margin: 0 8px 0 8px;\n  padding: 8px;\n  color: #050505;\n  cursor: pointer;\n  line-height: 16px;\n  font-size: 15px;\n  display: flex;\n  align-content: center;\n  flex-direction: row;\n  flex-shrink: 0;\n  background-color: #fff;\n  /* border-radius: 8px; */\n  border: 0;\n}\n\n.typeahead-popover li.active {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  background-size: contain;\n}\n\n/* .typeahead-popover li:first-child {\n  border-radius: 8px 8px 0px 0px;\n}\n\n.typeahead-popover li:last-child {\n  border-radius: 0px 0px 8px 8px;\n} */\n\n.typeahead-popover li:hover {\n  background-color: #eee;\n}\n\n.typeahead-popover li .text {\n  display: flex;\n  line-height: 20px;\n  flex-grow: 1;\n  min-width: 150px;\n}\n\n.typeahead-popover li .icon {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  user-select: none;\n  margin-right: 8px;\n  line-height: 16px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.component-picker-menu {\n  width: 200px;\n}\n\n.mentions-menu {\n  width: 250px;\n}\n\n.auto-embed-menu {\n  width: 0px;\n  border: none;\n}\n\n.emoji-menu {\n  width: 200px;\n}\n\ni.palette {\n  background-image: url(../../assets/images/icons/palette.svg);\n}\n\ni.bucket {\n  background-image: url(../../assets/images/icons/paint-bucket.svg);\n}\n\ni.bold {\n  background-image: url(../../assets/images/icons/type-bold.svg);\n}\n\ni.italic {\n  background-image: url(../../assets/images/icons/type-italic.svg);\n}\n\ni.clear {\n  background-image: url(../../assets/images/icons/trash.svg);\n}\n\ni.code {\n  background-image: url(../../assets/images/icons/code.svg);\n}\n\ni.underline {\n  background-image: url(../../assets/images/icons/type-underline.svg);\n}\n\ni.strikethrough {\n  background-image: url(../../assets/images/icons/type-strikethrough.svg);\n}\n\ni.subscript {\n  background-image: url(../../assets/images/icons/type-subscript.svg);\n}\n\ni.superscript {\n  background-image: url(../../assets/images/icons/type-superscript.svg);\n}\n\ni.link {\n  background-image: url(../../assets/images/icons/link.svg);\n}\n\ni.horizontal-rule {\n  background-image: url(../../assets/images/icons/horizontal-rule.svg);\n}\n\n.icon.plus {\n  background-image: url(../../assets/images/icons/plus.svg);\n}\n\n.icon.caret-right {\n  background-image: url(../../assets/images/icons/caret-right-fill.svg);\n}\n\n.icon.dropdown-more {\n  background-image: url(../../assets/images/icons/dropdown-more.svg);\n}\n\n.icon.font-color {\n  background-image: url(../../assets/images/icons/font-color.svg);\n}\n\n.icon.font-family {\n  background-image: url(../../assets/images/icons/font-family.svg);\n}\n\n.icon.bg-color {\n  background-image: url(../../assets/images/icons/bg-color.svg);\n}\n\n.icon.table {\n  background-color: #6c757d;\n  mask-image: url(../../assets/images/icons/table.svg);\n  -webkit-mask-image: url(../../assets/images/icons/table.svg);\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n}\n\ni.image {\n  background-image: url(../../assets/images/icons/file-image.svg);\n}\n\ni.table {\n  background-image: url(../../assets/images/icons/table.svg);\n}\n\ni.close {\n  background-image: url(../../assets/images/icons/close.svg);\n}\n\ni.figma {\n  background-image: url(../../assets/images/icons/figma.svg);\n}\n\ni.poll {\n  background-image: url(../../assets/images/icons/card-checklist.svg);\n}\n\ni.columns {\n  background-image: url(../../assets/images/icons/3-columns.svg);\n}\n\ni.tweet {\n  background-image: url(../../assets/images/icons/tweet.svg);\n}\n\ni.youtube {\n  background-image: url(../../assets/images/icons/youtube.svg);\n}\n\n.icon.left-align,\ni.left-align {\n  background-image: url(../../assets/images/icons/text-left.svg);\n}\n\n.icon.center-align,\ni.center-align {\n  background-image: url(../../assets/images/icons/text-center.svg);\n}\n\n.icon.right-align,\ni.right-align {\n  background-image: url(../../assets/images/icons/text-right.svg);\n}\n\n.icon.justify-align,\ni.justify-align {\n  background-image: url(../../assets/images/icons/justify.svg);\n}\n\ni.indent {\n  background-image: url(../../assets/images/icons/indent.svg);\n}\n\ni.markdown {\n  background-image: url(../../assets/images/icons/markdown.svg);\n}\n\ni.outdent {\n  background-image: url(../../assets/images/icons/outdent.svg);\n}\n\ni.undo {\n  background-image: url(../../assets/images/icons/arrow-counterclockwise.svg);\n}\n\ni.redo {\n  background-image: url(../../assets/images/icons/arrow-clockwise.svg);\n}\n\ni.sticky {\n  background-image: url(../../assets/images/icons/sticky.svg);\n}\n\ni.mic {\n  background-image: url(../../assets/images/icons/mic.svg);\n}\n\ni.import {\n  background-image: url(../../assets/images/icons/upload.svg);\n}\n\ni.export {\n  background-image: url(../../assets/images/icons/download.svg);\n}\n\ni.diagram-2 {\n  background-image: url(../../assets/images/icons/diagram-2.svg);\n}\n\ni.user {\n  background-image: url(../../assets/images/icons/user.svg);\n}\n\ni.equation {\n  background-image: url(../../assets/images/icons/plus-slash-minus.svg);\n}\n\ni.gif {\n  background-image: url(../../assets/images/icons/filetype-gif.svg);\n}\n\ni.copy {\n  background-image: url(../../assets/images/icons/copy.svg);\n}\n\ni.success {\n  background-image: url(../../assets/images/icons/success.svg);\n}\n\ni.prettier {\n  background-image: url(../../assets/images/icons/prettier.svg);\n}\n\ni.prettier-error {\n  background-image: url(../../assets/images/icons/prettier-error.svg);\n}\n\ni.page-break,\n.icon.page-break {\n  background-image: url(../../assets/images/icons/scissors.svg);\n}\n\n.link-editor .button.active,\n.toolbar .button.active {\n  background-color: rgb(223, 232, 250);\n}\n\n.link-editor .link-input {\n  display: block;\n  width: calc(100% - 75px);\n  box-sizing: border-box;\n  margin: 12px 12px;\n  padding: 8px 12px;\n  border-radius: 15px;\n  background-color: #eee;\n  font-size: 15px;\n  color: rgb(5, 5, 5);\n  border: 0;\n  outline: 0;\n  position: relative;\n  font-family: inherit;\n}\n\n.link-editor .link-view {\n  display: block;\n  width: calc(100% - 24px);\n  margin: 8px 12px;\n  padding: 8px 12px;\n  border-radius: 15px;\n  font-size: 15px;\n  color: rgb(5, 5, 5);\n  border: 0;\n  outline: 0;\n  position: relative;\n  font-family: inherit;\n}\n\n.link-editor .link-view a {\n  display: block;\n  word-break: break-word;\n  width: calc(100% - 33px);\n}\n\n/* \n.link-editor div.link-edit {\n  background-image: url(../../assets/images/icons/pencil-fill.svg);\n  background-size: 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 35px;\n  vertical-align: -0.25em;\n  position: absolute;\n  right: 30px;\n  top: 0;\n  bottom: 0;\n  cursor: pointer;\n} */\n\n.link-editor div.link-trash {\n  background-image: url(../../assets/images/icons/trash.svg);\n  background-size: 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 35px;\n  vertical-align: -0.25em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.link-editor div.link-cancel {\n  background-image: url(../../assets/images/icons/close.svg);\n  background-size: 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 35px;\n  vertical-align: -0.25em;\n  margin-right: 28px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.link-editor div.link-confirm {\n  background-image: url(../../assets/images/icons/success-alt.svg);\n  background-size: 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 35px;\n  vertical-align: -0.25em;\n  margin-right: 2px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.link-editor .link-input a {\n  color: rgb(33, 111, 219);\n  text-decoration: underline;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 30px;\n  text-overflow: ellipsis;\n}\n\n.link-editor .link-input a:hover {\n  text-decoration: underline;\n}\n\n.link-editor .font-size-wrapper,\n.link-editor .font-family-wrapper {\n  display: flex;\n  margin: 0 4px;\n}\n\n.link-editor select {\n  padding: 6px;\n  border: none;\n  background-color: rgba(0, 0, 0, 0.075);\n  border-radius: 4px;\n}\n\n.mention:focus {\n  box-shadow: rgb(180 213 255) 0px 0px 0px 2px;\n  outline: none;\n}\n\n.characters-limit {\n  color: #888;\n  font-size: 12px;\n  text-align: right;\n  display: block;\n  position: absolute;\n  left: 12px;\n  bottom: 5px;\n}\n\n.characters-limit.characters-limit-exceeded {\n  color: red;\n}\n\n.dropdown {\n  z-index: 100;\n  display: block;\n  position: fixed;\n  box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.5);\n  border-radius: 8px;\n  min-height: 40px;\n  background-color: #fff;\n}\n\n.dropdown .item {\n  margin: 0 8px 0 8px;\n  padding: 8px;\n  color: #050505;\n  cursor: pointer;\n  line-height: 16px;\n  font-size: 15px;\n  display: flex;\n  align-content: center;\n  flex-direction: row;\n  flex-shrink: 0;\n  justify-content: space-between;\n  background-color: #fff;\n  border-radius: 8px;\n  border: 0;\n  max-width: 250px;\n  min-width: 100px;\n}\n\n.dropdown .item.fontsize-item,\n.dropdown .item.fontsize-item .text {\n  min-width: unset;\n}\n\n.dropdown .item .active {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  background-size: contain;\n}\n\n.dropdown .item:first-child {\n  margin-top: 8px;\n}\n\n.dropdown .item:last-child {\n  margin-bottom: 8px;\n}\n\n.dropdown .item:hover {\n  background-color: #eee;\n}\n\n.dropdown .item .text {\n  display: flex;\n  line-height: 20px;\n  flex-grow: 1;\n  min-width: 150px;\n}\n\n.dropdown .item .icon {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  user-select: none;\n  margin-right: 12px;\n  line-height: 16px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.dropdown .divider {\n  width: auto;\n  background-color: #eee;\n  margin: 4px 8px;\n  height: 1px;\n}\n\n@media screen and (max-width: 1100px) {\n  .dropdown-button-text {\n    display: none !important;\n  }\n\n  .dialog-dropdown>.dropdown-button-text {\n    display: flex !important;\n  }\n\n  .font-size .dropdown-button-text {\n    display: flex !important;\n  }\n\n  .code-language .dropdown-button-text {\n    display: flex !important;\n  }\n}\n\n.icon.paragraph {\n  background-image: url(../../assets/images/icons/text-paragraph.svg);\n}\n\n.icon.h1 {\n  background-image: url(../../assets/images/icons/type-h1.svg);\n}\n\n.icon.h2 {\n  background-image: url(../../assets/images/icons/type-h2.svg);\n}\n\n.icon.h3 {\n  background-image: url(../../assets/images/icons/type-h3.svg);\n}\n\n.icon.h4 {\n  background-image: url(../../assets/images/icons/type-h4.svg);\n}\n\n.icon.h5 {\n  background-image: url(../../assets/images/icons/type-h5.svg);\n}\n\n.icon.h6 {\n  background-image: url(../../assets/images/icons/type-h6.svg);\n}\n\n.icon.bullet-list,\n.icon.bullet {\n  background-image: url(../../assets/images/icons/list-ul.svg);\n}\n\n.icon.check-list,\n.icon.check {\n  background-image: url(../../assets/images/icons/square-check.svg);\n}\n\n.icon.numbered-list,\n.icon.number {\n  background-image: url(../../assets/images/icons/list-ol.svg);\n}\n\n.icon.quote {\n  background-image: url(../../assets/images/icons/chat-square-quote.svg);\n}\n\n.icon.code {\n  background-image: url(../../assets/images/icons/code.svg);\n}\n\n.switches {\n  z-index: 6;\n  position: fixed;\n  left: 10px;\n  bottom: 70px;\n  animation: slide-in 0.4s ease;\n}\n\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    transform: translateX(-200px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.switch {\n  display: block;\n  color: #444;\n  margin: 5px 0;\n  background-color: rgba(238, 238, 238, 0.7);\n  padding: 5px 10px;\n  border-radius: 10px;\n}\n\n#rich-text-switch {\n  right: 0;\n}\n\n#character-count-switch {\n  right: 130px;\n}\n\n.switch label {\n  margin-right: 5px;\n  line-height: 24px;\n  width: 100px;\n  font-size: 14px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.switch button {\n  background-color: rgb(206, 208, 212);\n  height: 24px;\n  box-sizing: border-box;\n  border-radius: 12px;\n  width: 44px;\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  outline: none;\n  cursor: pointer;\n  transition: background-color 0.1s;\n  border: 2px solid transparent;\n}\n\n.switch button:focus-visible {\n  border-color: blue;\n}\n\n.switch button span {\n  top: 0px;\n  left: 0px;\n  display: block;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border-radius: 12px;\n  background-color: white;\n  transition: transform 0.2s;\n}\n\n.switch button[aria-checked='true'] {\n  background-color: rgb(24, 119, 242);\n}\n\n.switch button[aria-checked='true'] span {\n  transform: translateX(20px);\n}\n\n.editor-shell span.editor-image {\n  cursor: default;\n  display: inline-block;\n  position: relative;\n  user-select: none;\n}\n\n.editor-shell .editor-image img {\n  max-width: 100%;\n  cursor: default;\n}\n\n.editor-shell .editor-image img.focused {\n  outline: 2px solid rgb(60, 132, 244);\n  user-select: none;\n}\n\n.editor-shell .editor-image img.focused.draggable {\n  cursor: grab;\n}\n\n.editor-shell .editor-image img.focused.draggable:active {\n  cursor: grabbing;\n}\n\n.editor-shell .editor-image .image-caption-container .tree-view-output {\n  margin: 0;\n  border-radius: 0;\n}\n\n.editor-shell .editor-image .image-caption-container {\n  display: block;\n  position: absolute;\n  bottom: 4px;\n  left: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid #fff;\n  background-color: rgba(255, 255, 255, 0.9);\n  min-width: 100px;\n  color: #000;\n  overflow: hidden;\n}\n\n.editor-shell .editor-image .image-caption-button {\n  display: block;\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n  width: 30%;\n  padding: 10px;\n  margin: 0 auto;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 5px;\n  background-color: rgba(0, 0, 0, 0.5);\n  min-width: 100px;\n  color: #fff;\n  cursor: pointer;\n  user-select: none;\n}\n\n.editor-shell .editor-image .image-caption-button:hover {\n  background-color: rgba(60, 132, 244, 0.5);\n}\n\n/* .editor-shell .editor-image .image-edit-button {\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 5px;\n  background-image: url(/src/../../assets/images/icons/pencil-fill.svg);\n  background-size: 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 35px;\n  height: 35px;\n  vertical-align: -0.25em;\n  position: absolute;\n  right: 4px;\n  top: 4px;\n  cursor: pointer;\n  user-select: none;\n} */\n\n.editor-shell .editor-image .image-edit-button:hover {\n  background-color: rgba(60, 132, 244, 0.1);\n}\n\n.editor-shell .editor-image .image-resizer {\n  display: block;\n  width: 7px;\n  height: 7px;\n  position: absolute;\n  background-color: rgb(60, 132, 244);\n  border: 1px solid #fff;\n}\n\n.editor-shell .editor-image .image-resizer.image-resizer-n {\n  top: -6px;\n  left: 48%;\n  cursor: n-resize;\n}\n\n.editor-shell .editor-image .image-resizer.image-resizer-ne {\n  top: -6px;\n  right: -6px;\n  cursor: ne-resize;\n}\n\n.editor-shell .editor-image .image-resizer.image-resizer-e {\n  bottom: 48%;\n  right: -6px;\n  cursor: e-resize;\n}\n\n.editor-shell .editor-image .image-resizer.image-resizer-se {\n  bottom: -2px;\n  right: -6px;\n  cursor: nwse-resize;\n}\n\n.editor-shell .editor-image .image-resizer.image-resizer-s {\n  bottom: -2px;\n  left: 48%;\n  cursor: s-resize;\n}\n\n.editor-shell .editor-image .image-resizer.image-resizer-sw {\n  bottom: -2px;\n  left: -6px;\n  cursor: sw-resize;\n}\n\n.editor-shell .editor-image .image-resizer.image-resizer-w {\n  bottom: 48%;\n  left: -6px;\n  cursor: w-resize;\n}\n\n.editor-shell .editor-image .image-resizer.image-resizer-nw {\n  top: -6px;\n  left: -6px;\n  cursor: nw-resize;\n}\n\n.editor-shell span.inline-editor-image {\n  cursor: default;\n  display: inline-block;\n  position: relative;\n  z-index: 1;\n}\n\n.editor-shell .inline-editor-image img {\n  max-width: 100%;\n  cursor: default;\n}\n\n.editor-shell .inline-editor-image img.focused {\n  outline: 2px solid rgb(60, 132, 244);\n}\n\n.editor-shell .inline-editor-image img.focused.draggable {\n  cursor: grab;\n}\n\n.editor-shell .inline-editor-image img.focused.draggable:active {\n  cursor: grabbing;\n}\n\n.editor-shell .inline-editor-image .image-caption-container .tree-view-output {\n  margin: 0;\n  border-radius: 0;\n}\n\n.editor-shell .inline-editor-image.position-full {\n  margin: 1em 0 1em 0;\n}\n\n.editor-shell .inline-editor-image.position-left {\n  float: left;\n  width: 50%;\n  margin: 1em 1em 0 0;\n}\n\n.editor-shell .inline-editor-image.position-right {\n  float: right;\n  width: 50%;\n  margin: 1em 0 0 1em;\n}\n\n.editor-shell .inline-editor-image .image-edit-button {\n  display: block;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  padding: 6px 8px;\n  margin: 0 auto;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 5px;\n  background-color: rgba(0, 0, 0, 0.5);\n  min-width: 60px;\n  color: #fff;\n  cursor: pointer;\n  user-select: none;\n}\n\n.editor-shell .inline-editor-image .image-edit-button:hover {\n  background-color: rgba(60, 132, 244, 0.5);\n}\n\n.editor-shell .inline-editor-image .image-caption-container {\n  display: block;\n  background-color: #f4f4f4;\n  min-width: 100%;\n  color: #000;\n  overflow: hidden;\n}\n\n.emoji {\n  color: transparent;\n  caret-color: rgb(5, 5, 5);\n  background-size: 16px 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  vertical-align: middle;\n  margin: 0 -1px;\n}\n\n.emoji-inner {\n  padding: 0 0.15em;\n}\n\n.emoji-inner::selection {\n  color: transparent;\n  background-color: rgba(150, 150, 150, 0.4);\n}\n\n.emoji-inner::moz-selection {\n  color: transparent;\n  background-color: rgba(150, 150, 150, 0.4);\n}\n\n.emoji.happysmile {\n  background-image: url(../../assets/images/emoji/1F642.png);\n}\n\n.emoji.veryhappysmile {\n  background-image: url(../../assets/images/emoji/1F600.png);\n}\n\n.emoji.unhappysmile {\n  background-image: url(../../assets/images/emoji/1F641.png);\n}\n\n.emoji.heart {\n  background-image: url(../../assets/images/emoji/2764.png);\n}\n\n.keyword {\n  color: rgb(241, 118, 94);\n  font-weight: bold;\n}\n\n.actions {\n  position: absolute;\n  text-align: right;\n  margin: 10px;\n  bottom: 0;\n  right: 0;\n}\n\n.actions.tree-view {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.actions i {\n  background-size: contain;\n  display: inline-block;\n  height: 15px;\n  width: 15px;\n  vertical-align: -0.25em;\n}\n\n.actions i.indent {\n  background-image: url(../../assets/images/icons/indent.svg);\n}\n\n.actions i.outdent {\n  background-image: url(../../assets/images/icons/outdent.svg);\n}\n\n.actions i.lock {\n  background-image: url(../../assets/images/icons/lock-fill.svg);\n}\n\n.actions i.image {\n  background-image: url(../../assets/images/icons/file-image.svg);\n}\n\n.actions i.table {\n  background-image: url(../../assets/images/icons/table.svg);\n}\n\n.actions i.unlock {\n  background-image: url(../../assets/images/icons/lock.svg);\n}\n\n.actions i.left-align {\n  background-image: url(../../assets/images/icons/text-left.svg);\n}\n\n.actions i.center-align {\n  background-image: url(../../assets/images/icons/text-center.svg);\n}\n\n.actions i.right-align {\n  background-image: url(../../assets/images/icons/text-right.svg);\n}\n\n.actions i.justify-align {\n  background-image: url(../../assets/images/icons/justify.svg);\n}\n\n.actions i.disconnect {\n  background-image: url(../../assets/images/icons/plug.svg);\n}\n\n.actions i.connect {\n  background-image: url(../../assets/images/icons/plug-fill.svg);\n}\n\n.table-cell-action-button-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  will-change: transform;\n}\n\n.table-cell-action-button {\n  background-color: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 0;\n  position: relative;\n  border-radius: 15px;\n  color: #222;\n  display: inline-block;\n  cursor: pointer;\n}\n\ni.chevron-down {\n  background-color: transparent;\n  background-size: contain;\n  display: inline-block;\n  height: 8px;\n  width: 8px;\n  background-image: url(../../assets/images/icons/chevron-down.svg);\n}\n\n.action-button {\n  background-color: #eee;\n  border: 0;\n  padding: 8px 12px;\n  position: relative;\n  margin-left: 5px;\n  border-radius: 15px;\n  color: #222;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.action-button:hover {\n  background-color: #ddd;\n  color: #000;\n}\n\n.action-button-mic.active {\n  animation: mic-pulsate-color 3s infinite;\n}\n\nbutton.action-button:disabled {\n  opacity: 0.6;\n  background: #eee;\n  cursor: not-allowed;\n}\n\n@keyframes mic-pulsate-color {\n  0% {\n    background-color: #ffdcdc;\n  }\n\n  50% {\n    background-color: #ff8585;\n  }\n\n  100% {\n    background-color: #ffdcdc;\n  }\n}\n\n.debug-timetravel-panel {\n  overflow: hidden;\n  padding: 0 0 10px 0;\n  margin: auto;\n  display: flex;\n}\n\n.debug-timetravel-panel-slider {\n  padding: 0;\n  flex: 8;\n}\n\n.debug-timetravel-panel-button {\n  padding: 0;\n  border: 0;\n  background: none;\n  flex: 1;\n  color: #fff;\n  font-size: 12px;\n}\n\n.debug-timetravel-panel-button:hover {\n  text-decoration: underline;\n}\n\n.debug-timetravel-button {\n  border: 0;\n  padding: 0;\n  font-size: 12px;\n  top: 10px;\n  right: 15px;\n  position: absolute;\n  background: none;\n  color: #fff;\n}\n\n.debug-timetravel-button:hover {\n  text-decoration: underline;\n}\n\n.debug-treetype-button {\n  border: 0;\n  padding: 0;\n  font-size: 12px;\n  top: 10px;\n  right: 85px;\n  position: absolute;\n  background: none;\n  color: #fff;\n}\n\n.debug-treetype-button:hover {\n  text-decoration: underline;\n}\n\n.connecting {\n  font-size: 15px;\n  color: #999;\n  overflow: hidden;\n  position: absolute;\n  text-overflow: ellipsis;\n  top: 10px;\n  left: 10px;\n  user-select: none;\n  white-space: nowrap;\n  display: inline-block;\n  pointer-events: none;\n}\n\n.ltr {\n  text-align: left;\n}\n\n.rtl {\n  text-align: right;\n}\n\n.toolbar {\n  display: flex;\n  vertical-align: middle;\n  overflow: auto;\n  height: 24px;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\nbutton.toolbar-item {\n  border: 0;\n  display: flex;\n  background: none;\n  border-radius: 2px;\n  padding: 3px;\n  cursor: pointer;\n  vertical-align: middle;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n}\n\nbutton.toolbar-item:disabled {\n  cursor: not-allowed;\n}\n\nbutton.toolbar-item.spaced {\n  margin-right: 2px;\n}\n\nbutton.toolbar-item i.format {\n  background-size: contain;\n  display: inline-block;\n  height: 18px;\n  width: 18px;\n  vertical-align: -0.25em;\n  display: flex;\n  opacity: 0.6;\n}\n\nbutton.toolbar-item:disabled .icon,\nbutton.toolbar-item:disabled .text,\nbutton.toolbar-item:disabled i.format,\nbutton.toolbar-item:disabled .chevron-down {\n  opacity: 0.2;\n}\n\nbutton.toolbar-item.active {\n  background-color: rgba(223, 232, 250, 0.3);\n}\n\nbutton.toolbar-item.active i {\n  opacity: 1;\n}\n\n.toolbar-item:hover:not([disabled]) {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.toolbar-item.font-family .text {\n  display: block;\n  max-width: 40px;\n}\n\n.toolbar .code-language {\n  width: 150px;\n}\n\n.toolbar .toolbar-item .text {\n  display: flex;\n  line-height: 20px;\n  vertical-align: middle;\n  font-size: 14px;\n  color: #777;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  height: 20px;\n  text-align: left;\n  padding-right: 10px;\n}\n\n.toolbar .toolbar-item .icon {\n  display: flex;\n  width: 15px;\n  height: 15px;\n  user-select: none;\n  margin-right: 2px;\n  line-height: 14px;\n  background-size: contain;\n}\n\n.toolbar i.chevron-down,\n.toolbar-item i.chevron-down {\n  margin-top: 2px;\n  width: 8px;\n  height: 8px;\n  display: flex;\n  user-select: none;\n}\n\n.toolbar i.chevron-down.inside {\n  width: 8px;\n  height: 8px;\n  display: flex;\n  margin-left: -25px;\n  margin-top: 11px;\n  margin-right: 10px;\n  pointer-events: none;\n}\n\n.toolbar .divider {\n  width: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n  margin: 0 2px;\n}\n\n.sticky-note-container {\n  position: absolute;\n  z-index: 9;\n  width: 120px;\n  display: inline-block;\n}\n\n.sticky-note {\n  line-height: 1;\n  text-align: left;\n  width: 120px;\n  margin: 25px;\n  padding: 20px 10px;\n  position: relative;\n  border: 1px solid #e8e8e8;\n  font-family: 'Reenie Beanie';\n  font-size: 24px;\n  border-bottom-right-radius: 60px 5px;\n  display: block;\n  cursor: move;\n}\n\n.sticky-note:after {\n  content: '';\n  position: absolute;\n  z-index: -1;\n  right: -0px;\n  bottom: 20px;\n  width: 120px;\n  height: 25px;\n  background: rgba(0, 0, 0, 0.2);\n  box-shadow: 2px 15px 5px rgba(0, 0, 0, 0.4);\n  transform: matrix(-1, -0.1, 0, 1, 0, 0);\n}\n\n.sticky-note.yellow {\n  border-top: 1px solid #fdfd86;\n  background: linear-gradient(135deg,\n      #ffff88 81%,\n      #ffff88 82%,\n      #ffff88 82%,\n      #ffffc6 100%);\n}\n\n.sticky-note.pink {\n  border-top: 1px solid #e7d1e4;\n  background: linear-gradient(135deg,\n      #f7cbe8 81%,\n      #f7cbe8 82%,\n      #f7cbe8 82%,\n      #e7bfe1 100%);\n}\n\n.sticky-note-container.dragging {\n  transition: none !important;\n}\n\n.sticky-note div {\n  cursor: text;\n}\n\n.sticky-note .delete {\n  border: 0;\n  background: none;\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  font-size: 10px;\n  cursor: pointer;\n  opacity: 0.5;\n}\n\n.sticky-note .delete:hover {\n  font-weight: bold;\n  opacity: 1;\n}\n\n.sticky-note .color {\n  border: 0;\n  background: none;\n  position: absolute;\n  top: 8px;\n  right: 25px;\n  cursor: pointer;\n  opacity: 0.5;\n}\n\n.sticky-note .color:hover {\n  opacity: 1;\n}\n\n.sticky-note .color i {\n  display: block;\n  width: 12px;\n  height: 12px;\n  background-size: contain;\n}\n\n.excalidraw-button {\n  border: 0;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n}\n\n.excalidraw-button.selected {\n  outline: 2px solid rgb(60, 132, 244);\n  user-select: none;\n}\n\n.github-corner:hover .octo-arm {\n  animation: octocat-wave 560ms ease-in-out;\n}\n\n@keyframes octocat-wave {\n\n  0%,\n  100% {\n    transform: rotate(0);\n  }\n\n  20%,\n  60% {\n    transform: rotate(-25deg);\n  }\n\n  40%,\n  80% {\n    transform: rotate(10deg);\n  }\n}\n\n@media (max-width: 500px) {\n  .github-corner:hover .octo-arm {\n    animation: none;\n  }\n\n  .github-corner .octo-arm {\n    animation: octocat-wave 560ms ease-in-out;\n  }\n}\n\n.spacer {\n  letter-spacing: -2px;\n}\n\n.editor-equation {\n  cursor: default;\n  user-select: none;\n}\n\n.editor-equation.focused {\n  outline: 2px solid rgb(60, 132, 244);\n}\n\nbutton.item i {\n  opacity: 0.6;\n}\n\nbutton.item.dropdown-item-active {\n  background-color: rgba(223, 232, 250, 0.3);\n}\n\nbutton.item.dropdown-item-active i {\n  opacity: 1;\n}\n\nhr {\n  /* padding: 2px 2px; */\n  margin: 2px 2px;\n  border: none;\n  margin: 1em 0;\n  cursor: pointer;\n}\n\nhr:after {\n  content: '';\n  display: block;\n  height: 2px;\n  background-color: #ccc;\n  line-height: 2px;\n}\n\nhr.selected {\n  outline: 2px solid rgb(60, 132, 244);\n  user-select: none;\n}\n\n.TableNode__contentEditable {\n  min-height: 20px;\n  border: 0px;\n  resize: none;\n  cursor: text;\n  display: block;\n  position: relative;\n  outline: 0px;\n  padding: 0;\n  user-select: text;\n  font-size: 15px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  z-index: 3;\n}\n\n.PlaygroundEditorTheme__blockCursor {\n  display: block;\n  pointer-events: none;\n  position: absolute;\n}\n\n.PlaygroundEditorTheme__blockCursor:after {\n  content: '';\n  display: block;\n  position: absolute;\n  top: -2px;\n  width: 20px;\n  border-top: 1px solid black;\n  animation: CursorBlink 1.1s steps(2, start) infinite;\n}\n\n@keyframes CursorBlink {\n  to {\n    visibility: hidden;\n  }\n}\n\n.dialog-dropdown {\n  background-color: #eee !important;\n  margin-bottom: 10px;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
